import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { PropsWithChildren } from "react"
import { useLocalization } from "@tm/localization"
import { IconButton } from "../../muiStyled/Inputs/button"
import { Icon } from "../../muiStyled/DataDisplay/Icons"
import { ListItemPaper, ListItemPaperProps } from "../../muiStyled/Surfaces/paper/paperListItem"
import { Tooltip } from "../../muiStyled/DataDisplay/tooltip"

type Props = ListItemPaperProps & {
    item: string
}

export function DraggableListItem({ item, sx, children, ...rest }: PropsWithChildren<Props>) {
    const { attributes, isDragging, listeners, setNodeRef, setActivatorNodeRef, transform, transition } = useSortable({ id: item })
    const { translateText } = useLocalization()

    return (
        <ListItemPaper
            {...rest}
            ref={setNodeRef}
            sx={{
                transform: CSS.Translate.toString(transform),
                transition,
                zIndex: isDragging ? 1 : undefined,
                display: "flex",
                alignItems: "center",
                gap: "10px",
                ...sx,
            }}
        >
            {children}
            <Tooltip title={translateText(14050)}>
                <IconButton ref={setActivatorNodeRef} {...listeners} {...attributes} size="large" variant="contained">
                    <Icon name="move" size="inherit" />
                </IconButton>
            </Tooltip>
        </ListItemPaper>
    )
}
